import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';

//export const API_SERVER = 'https://localhost:7206/';
const protocol = window.location.protocol;
const hostname = window.location.hostname;
const host = window.location.host;
let apiUrl = `${protocol}//${host}/`;
if (hostname === 'localhost') {
    apiUrl = 'https://localhost:7206/';
} else {
    apiUrl = 'https://candidate.viva-holidays.co.in/';
}
export const API_SERVER = apiUrl;

export const initializeFilterData = {
    "SearchText": "",
    "StartValue": "1",
    "SearchFieldValue": "",
    "PageSize": "10",
    "AdvanceFilter": []
}

export const AutoCompleteList = ( Type , Token, preFix, ContextKey, ContextKey2, cb) => {
        fetch(`${API_SERVER}api/AutoComplete/GetAutoComplete`, {
            method: 'POST',
            body: JSON.stringify({ ...Token, Type, preFix, ContextKey, ContextKey2 }),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((res) => res.json())
            .then((res) => {
                cb({res})
            })
            .catch((err) => (err))
}


export const handleDownloadExcel = async (handleApiUrl, requestData, FileName) => {
    const apiUrl = handleApiUrl;
    const requestBody = requestData
    const requestHeaders = {
        'Content-Type': 'application/json',
    };
    try {
        const response = await fetch(apiUrl, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: requestHeaders,
        });
        const res = await response.json();
        if (res.Status === "SUCCESS") {
            const workbook = XLSX.utils.book_new();
            let worksheet = XLSX.utils.aoa_to_sheet([
                res?.HeadersValue
                ,
                ...res?.Data?.map((records) =>
                    res.HeadersKey?.map((data, i) =>
                        records[data]
                    )
                ),
            ]);
            XLSX.utils.book_append_sheet(workbook, worksheet, FileName);
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
            const url = window.URL.createObjectURL(data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${FileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            return
        } else if (res.Status === 'ERROR') {
           // NotificationSound(res.Status, res.Message)
        }
    } catch (err) {
        toast.error(err.message, {
            position: 'top-center',
        });
    }


};